import { render } from "./bs-list.vue?vue&type=template&id=5c4e9ed2"
import script from "./bs-list.vue?vue&type=script&lang=js"
export * from "./bs-list.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__